module.exports = __webpack_public_path__ + "static/media/download.20570512.png";